import React, { FC } from "react";

import { useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { FormControl, Grid } from "@mui/material";

import { TrashCan } from "@/assets/icons";
import { InputLabel, PhoneNumberInput, TextInput } from "@/components/atoms";
import { RefSelectInput } from "@/components/molecules";
import { StyledDivider } from "@/styles/components";

import { CompanyFormType } from "../../../../formType";
import { StyledRemoveIconButton } from "../../../../styled";

type PhoneFormProps = {
    index: number;
    removePhone: () => void;
};

const PhoneForm: FC<PhoneFormProps> = ({ index, removePhone }) => {
    const { t } = useTranslation();

    const {
        control,
        formState: { errors: errorPhones },
    } = useFormContext<CompanyFormType>();

    const errors = errorPhones?.contact?.telephoneNumbers || [];

    const firstIndex = index === 0;

    return (
        <Grid container data-testid={`phone-form-${index}`} marginTop={firstIndex ? 1 : 0}>
            {!firstIndex && (
                <Grid item xs={12}>
                    <StyledDivider />
                </Grid>
            )}
            {!firstIndex && (
                <div style={{ position: "relative" }}>
                    <StyledRemoveIconButton aria-label={t("Common.RemovePhone")} onClick={removePhone} size="large">
                        <TrashCan />
                    </StyledRemoveIconButton>
                </div>
            )}
            <Grid item xs={12} sm={9}>
                <FormControl error={Boolean(errors[index]?.type) || Boolean(errors[index]?.number)}>
                    <InputLabel
                        text={t("Common.Phone")}
                        required
                        htmlFor={`contact.telephoneNumbers.${index}.number`}
                    />
                    <Grid container>
                        <Grid item xs={4}>
                            <RefSelectInput
                                required
                                name={`contact.telephoneNumbers.${index}.type`}
                                control={control}
                                label=""
                                withEmptyOption
                                table="phoneNumberType"
                            />
                        </Grid>
                        <Grid item xs={8}>
                            <PhoneNumberInput name={`contact.telephoneNumbers.${index}.number`} control={control} />
                        </Grid>
                    </Grid>
                </FormControl>
            </Grid>
            <Grid item xs={12} sm={9}>
                <TextInput
                    name={`contact.telephoneNumbers.${index}.description`}
                    label={t("Common.Description")}
                    control={control}
                />
            </Grid>
        </Grid>
    );
};

export default PhoneForm;
